import React, { useState } from 'react';
import SystemInfoFormGroup from './SystemInfoFormGroup';
import styles from './AddBESS.module.css';
import { useTokenCheck } from '../../hooks/useTokenCheck';
import Button from '@material-ui/core/Button';
import { useTranslation } from 'react-i18next';
import ModulesFormGroup from './ModulesFormGroup';
import { Notify } from 'notiflix';
import { useSelector } from 'react-redux';
import { SENSORS } from '../../config';
import { postSystem } from '../../api/systemService';
import Header from '../Shared/Header';

export default function AddBESS() {
  useTokenCheck();
  const organizations = useSelector(
    (state) => state.organizationReducer.organizations
  );
  const { t } = useTranslation();
  const [systemName, setSystemName] = useState('');
  const [systemLocation, setSystemLocation] = useState('');
  const [systemOrganization, setSystemOrganization] = useState(
    organizations[0]
  );
  const [modules, setModules] = useState([]);
  const [systemSensors, setSystemSensors] = useState(
    Object.values(SENSORS).map((sensor) => ({ ...sensor, checked: false }))
  );

  const submitHandler = (e) => {
    e.preventDefault();
    const sensors = systemSensors
      .filter((sensor) => sensor.checked)
      .map((sensor) => ({
        sensorType: sensor.name,
        isCalculated: false
      }));
    const system = {
      name: systemName,
      longitude: 0,
      latitude: 0,
      location: systemLocation,
      organizationId: systemOrganization.organizationId,
      cabinets: [
        {
          name: 'Default cabinet',
          modules
        }
      ],
      sensors
    };
    postSystem(system).then((response) => {
      if (response.status >= 200 && response.status < 300) {
        Notify.success(t('systemAdded'));
        history.push('/systems');
      } else {
        Notify.failure(t('failure'));
      }
    });
  };

  return (
    <div className={styles.container}>
      <Header title={t('addSystem')} />
      <form className={styles.form} autoComplete="off" onSubmit={submitHandler}>
        <SystemInfoFormGroup
          systemName={systemName}
          setSystemName={setSystemName}
          systemLocation={systemLocation}
          setSystemLocation={setSystemLocation}
          systemOrganization={systemOrganization}
          setSystemOrganization={setSystemOrganization}
          modules={modules}
          setModules={setModules}
          systemSensors={systemSensors}
          setSystemSensors={setSystemSensors}
        />
        <ModulesFormGroup modules={modules} setModules={setModules} />
        <Button
          className={styles.submitButton}
          variant="contained"
          type="submit"
        >
          {t('finish')}
        </Button>
      </form>
    </div>
  );
}
